import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { merchantsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetLinkMerchantsListQuery = ({ agentId, options = {} }) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["linkMerchantsToAgent", agentId],
		() => merchantsService.getAgentSetupMerchantsList(agentId),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: error?.title,
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
			...options,
		},
	);

	return queryResult;
};

export default useGetLinkMerchantsListQuery;
